module.exports = __webpack_public_path__ + "media/images/contact-book-5814595d003fb14eeb911b1652b75880.svg";